
export default {
    props: {
        element: { type: Object }
    }
};
